import { useContext, useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { motion } from "framer-motion"

import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"

import { configAnim } from "../../../servicos/config/configAnim"
import { Avatar, Chip, Divider } from "@mui/material"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import { MdDeleteOutline, MdEdit, MdLogout, MdStar, MdPrivacyTip, MdSync } from "react-icons/md"
import { LogoBottom } from "./styles"
import ProfissionalAPI from "../../../servicos/ProfissionalAPI"

export default function Perfil() {
	const navegar = useNavigate()

	const { dados, deslogar } = useContext(ContextoGeral)

	const [menu, setMenu] = useState(false)
	const [avaliacaoProf, setAvaliacaoProf] = useState(false)
	const [TrocarCategoria, setTrocarCategoria] = useState('N')
	const [tipoVeiculo, setTipoVeiculo] = useState(dados.tipoVeiculo || '')

	const location = useLocation()

	useEffect(() => {
		ProfissionalAPI.avaliacao(dados).then(res => {
			setAvaliacaoProf(res.resultado)
		})

		ProfissionalAPI.buscarMenuExibir(dados).then(res => {
			setTrocarCategoria(res?.dados?.trocarCategoria)
		})

	}, [])

	useEffect(() => {
		if (location.state && location.state.tipoVeiculo) {
			setTipoVeiculo(location.state.tipoVeiculo)
		}
	}, [location.state])

	return (
		<motion.div
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
			className="h-lvh flex flex-col justify-between"
		> 
			<div>
				<TopoMenu voltar="/app/home" titulo="PERFIL" setShow={setMenu} />
				<div className="mx-3 py-4 flex items-center h-auto">
					<Avatar src={dados.foto} sx={{ width: 64, height: 64 }} />
					<div className="flex flex-col w-full">
						<h4 className="ml-3">{dados.nome}</h4>

						<div className="w-full flex justify-end items-center pb-0 pe-0 gap-2">
							<Chip
								color="primary"
								label={
									dados?.codigo
										? "Código #" + dados?.codigo
										: "ID prof. #" + dados.idProf
								}
								size="small"
							/>
							{tipoVeiculo && (
								<Chip
									color="primary"
									label={tipoVeiculo}
									size="small"
								/>
							)}
						</div>
					</div>

				</div>

				<Divider />
				<div
					className="mx-3 py-3 flex items-center"
					onClick={() => { navegar('/app/perfil/meusDados') }}
				>
					<MdEdit style={{ color: 'var(--primaria-pura)' }} size={30} />
					<h5 className="ml-3 mb-0 font-normal">Meus dados</h5>
				</div>
				<Divider />
				{TrocarCategoria === 'S' && <><div className="mx-3 py-3 flex items-center"
					onClick={() => navegar('/app/perfil/trocarCategoria')}
				>
					<MdSync style={{ color: 'var(--primaria-pura)' }} size={30} />
					<h5 className="ml-3 mb-0 font-normal">Alterar categoria</h5>
				</div>
					<Divider />
				</>}
				{avaliacaoProf && <>
					<div
						className="mx-3 py-3 flex items-center"
						onClick={() => { navegar('/app/perfil/avaliacao') }}
					>
						<MdStar style={{ color: 'var(--primaria-pura)' }} size={30} />
						<h5 className="ml-3 mb-0 font-normal">Minha Avaliação</h5>
					</div>
					<Divider />
				</>}
				<div
					className="mx-3 py-3 flex items-center"
					onClick={() => { navegar('/app/politicaPrivacidade') }}
				>
					<MdPrivacyTip style={{ color: 'var(--primaria-pura)' }} size={30} />
					<h5 className="ml-3 mb-0 font-normal">Política de privacidade</h5>
				</div>
				<Divider />
				<div
					className="mx-3 py-3 flex items-center"
					onClick={() => { navegar('/app/perfil/excluirConta') }}
				>
					<MdDeleteOutline style={{ color: '#c62828' }} size={30} />
					<h5 className="ml-3 mb-0 font-normal" style={{ color: '#c62828' }}>Excluir conta</h5>
				</div>
				<Divider />
				<div
					className="mx-3 py-3 flex items-center"
					onClick={() => { deslogar() }}
				>
					<MdLogout style={{ color: 'var(--primaria-pura)' }} size={30} />
					<h5 className="ml-3 mb-0 font-normal">Sair</h5>
				</div>
				<Divider />
			</div>
			<div className="text-center flex-1 flex justify-center w-full relative">
				<LogoBottom
					src={dados.config?.logo}
					className="mb-3 absolute bottom-0 font-normal"
					alt=""
					onClick={() => { navegar("/app/home") }}
				/>
			</div>
			<MenuLateral show={menu} setShow={setMenu} />
		</motion.div>
	)
}
